// tslint:disable: max-line-length
import { CharacterName } from "../GameObjects/Character";
import { Culture } from "./Culture";

// UI
/** Game title: "Carmen’s World Orchestra!" */
export const U1: string = "U1-Carmen-LATW-Digital-112719-T_01B";
/** Button: Play: "Play." */
export const U2: string = "U2-Carmen-LATW-Digital-112719-T_01B";
/** Button: Play again: "Play again." */
export const U3: string = "U3-Carmen-LATW-Digital-112719-T_01B";
/** Button: Next: "Next!" */
export const U4: string = "U4-Carmen-LATW-Digital-112719-T_01A";
/** End game #1 (choose variant at random): "That was a great concert! Let’s do it again." */
export const U5: string = "U5-Carmen-LATW-Digital-112719-T_02A";
/** End game #2: "Listen to that crowd roar! I think they want more!" */
export const U6: string = "U6-Carmen-LATW-Digital-112719-T_01A";
/** End game #3: "That was amazing! Let’s play another concert!" */
export const U7: string = "U7-Carmen-LATW-Digital-112719-T_03A";
/** Button: Confetti: "Confetti!" */
export const U8: string = "U8-Carmen-LATW-Digital-112719-T_01A";
/** Button: Balloons: "Balloons!" */
export const U9: string = "U9-Carmen-LATW-Digital-112719-T_01A";
/** Button: Lights: "Lights!" */
export const U10: string = "U10-Carmen-LATW-Digital-112719-T_01B";
/** Reacting to Luna dancing: "Nice dance Luna!" */
export const U11: string = "U11-Carmen-LATW-Digital-112719-T_01A";
/** Globe: Mexico: "Welcome to Mexico!" */
export const U12: string = "U12-Carmen-LATW-Digital-112719-T_01A";
/** Globe: India: "Welcome to India" */
export const U13: string = "U13-Carmen-LATW-Digital-112719-T_01A";
/** Globe: Egypt: "Welcome to Egypt" */
export const U14: string = "U14-Carmen-LATW-Digital-112719-T_01A";
/** Globe: Hover: "Magic Globe" */
export const U15: string = "U15-Carmen-LATW-Digital-112719-T_03B";
/** End Game Screen: "You can download your photo with this button" */
export const U16: string = "U16-Carmen-LATW-Digital-112719-T_02B";
/** End Game Screen: "Download photo!" */
export const U17: string = "U17-Carmen-LATW-Digital-112719-T_01B";
/** Photo Button: "Photo!" */
export const U18: string = "U17-Carmen-LATW-Digital-112719-T_01B_trimmed";

// In Game
/** Luna dance: "Nice moves, Luna!" */
export const I1: string = "I1-Carmen-LATW-Digital-112719-T_01A";
/** Luna dance: "Luna has a new dance move to show us!" */
export const I2: string = "I2-Carmen-LATW-Digital-112719-T_03B";
/** Luna dance: "Wow! Luna is such a great dancer!" */
export const I3: string = "I3-Carmen-LATW-Digital-112719-T_01B";
/** Luna dance: "This happy beat makes Luna move her feet!" */
export const I4: string = "I4-Carmen-LATW-Digital-112719-T_01A";
/** Luna dance: "Look at Luna go! It’s a new dance move." */
export const I5: string = "I5-Carmen-LATW-Digital-112719-T_02B";
/** Solo intro: Andy (Mex): "Andy is playing the Trumpet" */
export const I6: string = "I6-Carmen-LATW-Digital-112719-T_01A";
/** Solo intro: Andy (Ind): "Andy is playing the Bansuri" */
export const I7: string = "I7-Carmen-LATW-Digital-112719-T_01B";
/** Solo intro: Andy (Egy): "Andy is playing the Mizmar" */
export const I8: string = "I8-Carmen-LATW-Digital-112719-T_01A";
/** Solo intro: Leo (Mex): "Leo is playing the Violin" */
export const I9: string = "I9-Carmen-LATW-Digital-112719-T_01A";
/** Solo intro: Leo (Ind): "Leo is playing the Kingri" */
export const I10: string = "I10-Carmen-LATW-Digital-112719-T_01B";
/** Solo intro: Leo (Egy): "Leo is playing the Rababa" */
export const I11: string = "I11-Carmen-LATW-Digital-112719-T_01A";
/** Solo intro: Carmen (Mex): "I’m playing the Spanish Guitar" */
export const I12: string = "I12-Carmen-LATW-Digital-112719-T_01B";
/** Solo intro: Carmen (Ind): "I’m playing the Sitar" */
export const I13: string = "I13-Carmen-LATW-Digital-112719-T_01A";
/** Solo intro: Carmen (Egy): "I’m playing the Oud" */
export const I14: string = "I14-Carmen-LATW-Digital-112719-T_01B";
/** Finish game: "Time for the big finale!" */
export const I15: string = "I15-Carmen-LATW-Digital-112719-T_01A";
/** Finish game: "I think we’re ready for the big finale!" */
export const I16: string = "I16-Carmen-LATW-Digital-112719-T_01B";
/** Finish game: "What a performance, let’s do our big finale!" */
export const I17: string = "I17-Carmen-LATW-Digital-112719-T_01A";

// Instrument Names
/** Spanish guitar */
export const B1: string = "B1-Carmen-LATW-Digital-112719-T_01A";
/** Marimba */
export const B2: string = "B2-Carmen-LATW-Digital-112719-T_01A";
/** Cajón */
export const B3: string = "B3-Carmen-LATW-Digital-112719-T_01A";
/** Trumpet */
export const B4: string = "B4-Carmen-LATW-Digital-112719-T_01B";
/** Violin */
export const B5: string = "B5-Carmen-LATW-Digital-112719-T_01B";
/** Harp */
export const B6: string = "B6-Carmen-LATW-Digital-112719-T_01A";
/** Tabla */
export const B7: string = "B7-Carmen-LATW-Digital-112719-T_01A";
/** Edakka */
export const B8: string = "B8-Carmen-LATW-Digital-112719-T_01A";
/** Sitar */
export const B9: string = "B9-Carmen-LATW-Digital-112719-T_01A";
/** Kingri */
export const B10: string = "B10-Carmen-LATW-Digital-112719-T_01A";
/** Bansuri */
export const B11: string = "B11-Carmen-LATW-Digital-112719-T_01A";
/** Tambourine */
export const B12: string = "B12-Carmen-LATW-Digital-112719-T_01A";
/** Sagat */
export const B13: string = "B13-Carmen-LATW-Digital-112719-T_01B";
/** Ney */
export const B14: string = "B14-Carmen-LATW-Digital-112719-T_02B";
/** Oud */
export const B15: string = "B15-Carmen-LATW-Digital-112719-T_01A";
/** Rababa */
export const B16: string = "B16-Carmen-LATW-Digital-112719-T_01B";
/** Mizmar */
export const B17: string = "B17-Carmen-LATW-Digital-112719-T_01A";
/** Rubab */
export const B18: string = "B18-Carmen-LATW-Digital-112719-T_01A";

// Onboarding
/** Prompt: Tap solo: "Select Andy, Leo, or me Carmen and we’ll play a tune for you." */
export const O1: string = "O1-Carmen-LATW-Digital-112719-T_01B";
/** Prompt: Tap sample pad: "Select any instrument at the bottom to hear how it sounds." */
export const O2: string = "O2-Carmen-LATW-Digital-112719-T_01A";
/** Prompt: Tap VFX buttons: "Use these buttons for some fun effects!" */
export const O3: string = "O3-Carmen-LATW-Digital-112719-T_02B";
/** Prompt: Region Change: "Select the Magic Globe to change the style of music!" */
export const O4: string = "O4-Carmen-LATW-Digital-112719-T_02A";
/** Prompt: Freeplay: "Now it’s your turn to create beautiful music." */
export const O5: string = "O5-Carmen-LATW-Digital-112719-T_02A";
/** Intro: "We’re putting on a concert with instruments from all around the world! And you can play too! The more we play, the more Luna dances!" */
export const O6: string = "O6-Carmen-LATW-Digital-112719-T_01A";

// Facts
/** "A performer usually sits with legs crossed while playing the sitar." */
export const E1: string = "E1COMP-Carmen-LATW-Digital-112719-T_03";
/** The body of the sitar is made from a hollowed-out gourd, which is sort of like a pumpkin. */
export const E2: string = "E2-Carmen-LATW-Digital-112719-T_01B";
/** The sitar, like the oud, is often accompanied by drums. */
export const E3: string = "E3-Carmen-LATW-Digital-112719-T_01B";

/** The oud is a stringed instrument that’s popular in Arabic, Persian, and Turkish music. */
export const E4: string = "E4-Carmen-LATW-Digital-112719-T_02A";
/** The oud, like the sitar, is usually played with a plectrum, or pick. */
export const E5: string = "E5-Carmen-LATW-Digital-112719-T_01B";
/** The body of the oud is shaped sort of like a pear. */
export const E6: string = "E6-Carmen-LATW-Digital-112719-T_01A";

/** The guitar is played around the world in many musical styles, including blues, benga, mariachi, and reggae. */
export const E7: string = "E7-Carmen-LATW-Digital-112719-T_02A";
/** The ‘sound hole’ in the center of an acoustic guitar helps to make it louder. */
export const E8: string = "E8-Carmen-LATW-Digital-112719-T_01B";
/** The long, narrow part of a guitar is called ‘the neck,’ while the wider section is called ‘the body.’ */
export const E9: string = "E9-Carmen-LATW-Digital-112719-T_01A";

/** A violin can also be called a fiddle, depending on the style of music being played. */
export const E10: string = "E10-Carmen-LATW-Digital-112719-T_01B";
/** The violin is one of the most popular musical instruments in the world. */
export const E11: string = "E11-Carmen-LATW-Digital-112719-T_01A";
/** A violinist usually holds the violin between the chin and shoulder and pulls a bow across its strings to create a musical sound. */
export const E12: string = "E12-Carmen-LATW-Digital-112719-T_02A";

/** The neck of the kingri is made of bamboo, while the body can be made of various materials like coconut shell, gourd, or wood. */
export const E13: string = "E13-Carmen-LATW-Digital-112719-T_01A";
/** Like the rababa, the kingri typically has one, two or three strings. */
export const E14: string = "E14-Carmen-LATW-Digital-112719-T_01B";
/** Like the violin and rababa, the kingri is called a ‘bowed’ instrument because a bow is pulled across its strings to create music. */
export const E15: string = "E15-Carmen-LATW-Digital-112719-T_01A";

/** The rababa, like the kingri, is often played at celebrations, like weddings or festivals. */
export const E16: string = "E16-Carmen-LATW-Digital-112719-T_01A";
/** Unlike with the violin, a performer usually holds the rababa upright. */
export const E17: string = "E17-Carmen-LATW-Digital-112719-T_02B";
/** Some say the rababa is the first bowed instrument ever invented…sort of like the grandparent of the violin. */
export const E18: string = "E18-Carmen-LATW-Digital-112719-T_01B";

/** "To play a trumpet, you press your lips against the mouthpiece and blow. This causes your lips to vibrate, helping to create the trumpet's unique sound." */
export const E19: string = "E19-Carmen-LATW-Digital-112719-T_01B";
/** The trumpet is similar to the bansuri and mizmar in some ways, but it is made from metal instead of wood. */
export const E20: string = "E20-Carmen-LATW-Digital-112719-T_01B";
/** For many early human cultures, animal horns or tusks were used as the first trumpet-like instruments. */
export const E21: string = "E21-Carmen-LATW-Digital-112719-T_01B";
/** Trumpet, like guitar, is featured in many types of world music: jazz, classical, mariachi, and funk. */
export const E22: string = "E22-Carmen-LATW-Digital-112719-T_01A";

/** The bansuri is a flute made of bamboo. */
export const E23: string = "E23-Carmen-LATW-Digital-112719-T_01B";
/** The bansuri, like the oud, is often accompanied by drums */
export const E24: string = "E24-Carmen-LATW-Digital-112719-T_01B";
/** The bansuri, like the sitar, is usually played while the performer sits on the floor. */
export const E25: string = "E25-Carmen-LATW-Digital-112719-T_01B";

/** Mizmar bands often play at Egyptian weddings. */
export const E26: string = "E26-Carmen-LATW-Digital-112719-T_01B";
/** Mizmar are typically made from the wood of an apricot tree. */
export const E27: string = "E27-Carmen-LATW-Digital-112719-T_02B";
/** Mizmar players sometimes breathe in through the nose while blowing out through the mouth so they can hold long musical notes. */
export const E28: string = "E28-Carmen-LATW-Digital-112719-T_01A";

type _Culture = Exclude<Culture, Culture.NumElements>;
type _CharacterName = Exclude<CharacterName, CharacterName.NumElements>;

export const CULTURE: {[index in _Culture]: string} = {
    [Culture.Mexico]: U12,
    [Culture.India]: U13,
    [Culture.Egypt]: U14,
};

export const INSTRUMENT: {[culture in _Culture]: {[character in _CharacterName]: string}} = {
    [Culture.Mexico]: {
        [CharacterName.Andy]: I6,
        [CharacterName.Carmen]: I12,
        [CharacterName.Leo]: I9,
    },
    [Culture.India]: {
        [CharacterName.Andy]: I7,
        [CharacterName.Carmen]: I13,
        [CharacterName.Leo]: I10,
    },
    [Culture.Egypt]: {
        [CharacterName.Andy]: I8,
        [CharacterName.Carmen]: I14,
        [CharacterName.Leo]: I11,
    },
};

export const FACT: {[culture in _Culture]: {[character in _CharacterName]: string[]}} = {
    [Culture.Mexico]: {
        [CharacterName.Andy]: [E19, E20, E21, E22],
        [CharacterName.Carmen]: [E7, E8, E9],
        [CharacterName.Leo]: [E10, E11, E12],
    },
    [Culture.India]: {
        [CharacterName.Andy]: [E23, E24, E25],
        [CharacterName.Carmen]: [E1, E2, E3],
        [CharacterName.Leo]: [E13, E14, E15],
    },
    [Culture.Egypt]: {
        [CharacterName.Andy]: [E26, E27, E28],
        [CharacterName.Carmen]: [E4, E5, E6],
        [CharacterName.Leo]: [E16, E17, E18],
    },
};

export const INSTRUMENT_NAMES: {[index in _Culture]: [string, string, string, string, string, string]} = {
    [Culture.Mexico]: [B1, B2, B3, B4, B5, B6],
    [Culture.India]: [B7, B8, B9, B10, B11, B12],
    [Culture.Egypt]: [B13, B14, B15, B16, B17, B18],
};
